<template>
  <div class="row my-5 div-history">
    <div class="col-12">
      <legend>{{ translate.labelVideosDown }}</legend>
      <span class="subtitle">{{ translate.subLabelVideosDown }}</span>
    </div>
    <div class="col-lg-12">
      <Load v-model:active="loading" :is-full-page="false" :opacity="0.5" color="#b20000" />
      <table class="table">
        <thead>
          <tr>
            <th scope="col">{{ translate.orderStatus }}</th>
            <th scope="col">{{ translate.orderVideoName }}</th>
            <th scope="col">{{ translate.orderCreditUsed }}</th>
            <th scope="col">{{ translate.orderLinkDownload }}</th>
            <th scope="col">{{ translate.orderDate }}</th>
            <th scope="col">{{ translate.orderDateExpired }}</th>
          </tr>
        </thead>
        <tbody v-if="orders.length > 0">
          <tr v-for="order in orders" :key="order.id">
            <th scope="row">
              {{ statusLabel(order) }}
            </th>
            <td>
              {{ order.videoName }}
              {{ order.type ? `- ${order.type.toUpperCase()}` : '' }}
            </td>
            <td class="text-center">
              <strong>{{ order.creditsUsed }}</strong>
            </td>
            <td>
              <div
                v-if="order.path"
                class="col-12 d-flex justify-content-center align-items-center"
              >
                <a
                  :href="downloadLabel(order) == 'Download' ? order.path : '#'"
                  download
                  :class="downloadLabel(order) == 'Download' ? 'button' : 'button-expired'"
                  target="_blank"
                >
                  {{ downloadLabel(order) }}
                  <i class="icon-download"></i>
                </a>
              </div>
              <p v-else>{{ 'Indisponível' }}</p>
            </td>
            <td>{{ order.orderDate }}</td>
            <td>{{ order.path ? addSevenDays(order.orderDate) : '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { localeStore } from '../../stores/locale'
  import tradutor from '../../tradutors/videodownload'
  import api from '../../api'
  import Load from 'vue-loading-overlay'
  import { computed, ref } from 'vue'
  const storeLocale = localeStore()

  const orders = ref<any[]>([])
  const loading = ref<boolean>(false)

  const translate = computed(() => {
    getHistory()
    if (storeLocale.locale === 'pt-br') {
      return tradutor.portugues
    } else {
      return tradutor.ingles
    }
  })

  function addSevenDays(dateString: string): string {
    // Converter a string de data para um objeto Date
    const date = new Date(dateString.split('/').reverse().join('-'))

    // Adicionar 7 dias à data
    date.setDate(date.getDate() + 7)

    // Formatar a data resultante no formato dd/mm/yyyy
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${day}/${month}/${year}`
  }

  function statusLabel(order: any) {
    return storeLocale.locale == 'pt-br'
      ? order.status
        ? 'Disponível'
        : order.path
        ? 'Expirado'
        : 'Processando'
      : order.status
      ? 'Available'
      : order.path
      ? 'Expired'
      : 'Processing'
  }

  function downloadLabel(order: any) {
    return storeLocale.locale == 'pt-br'
      ? order.status
        ? 'Download'
        : 'Expirado'
      : order.status
      ? 'Download'
      : 'Expired'
  }

  async function getHistory() {
    loading.value = true
    api
      .get('v1/videoscredits/getHistoricoVideosDownload?locale=' + storeLocale.locale)
      .then(({ data }) => {
        orders.value = data
      })
      .catch((error) => console.log(error))
      .finally(() => (loading.value = false))
  }
</script>
<style scoped lang="css">
  legend {
    font-family: 'Roboto-Medium';
    line-height: 28px;
    font-size: 24px;
    color: #b40909;
    margin-bottom: 15px;
  }

  .subtitle {
    font-family: 'Roboto-Regular';
    line-height: 19px;
    font-size: 16px;
  }

  .table > :not(caption) > * > * {
    background-color: #fff;
  }
  .button {
    color: #ffffff;
    font-family: 'Exo-2';
    font-size: 16px;
    letter-spacing: 0;
  }

  .button-expired {
    letter-spacing: 0;
    display: inline-flex;
    align-items: center;
    height: 50px;
    padding: 0 25px;
    font-family: 'Exo 2', sans-serif;
    font-size: 16px;
    font-weight: normal;
    color: #ffffff;
    background-color: #282121a3;
    line-height: normal;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
    border-bottom-left-radius: 25px;
    -webkit-border-top-left-radius: 25px;
    -webkit-border-top-right-radius: 25px;
    -webkit-border-bottom-right-radius: 25px;
    -webkit-border-bottom-left-radius: 25px;
    -moz-border-radius-topleft: 25px;
    -moz-border-radius-topright: 25px;
    -moz-border-radius-bottomright: 25px;
    -moz-border-radius-bottomleft: 25px;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    border: solid 2px transparent;
    white-space: nowrap;
    cursor: not-allowed;
  }
  .table {
    margin-top: 32px;
    margin-left: 16px;
  }

  thead > tr > th {
    font-family: 'Roboto-Regular';
    font-size: 16px;
    line-height: 19px;
    color: #999;
    padding: 23px 16px;
  }

  tbody > tr > td {
    font-family: 'Exo-2';
    font-size: 18px;
    line-height: 18px;
    color: #000;
    padding: 23px 16px;
  }

  tbody > tr > th {
    font-family: 'Exo-2';
    font-size: 18px;
    line-height: 18px;
    color: #000;
    padding: 23px 16px;
  }

  thead,
  tbody,
  tfoot,
  tr,
  td,
  th {
    border-color: #ddd;
    border-style: solid;
    border-width: 1px;
  }

  .div-history {
    margin-left: 15px;
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .div-history {
      overflow: auto;
    }

    .subtitle {
      margin-left: unset;
    }
  }
</style>
